<patron-filter-widget
  class="sprint-filter-button"
  [findOptions]="findOptions"
  [showActiveFilters]="false"
  (onSubmit)="filterButtonClicked()"
  (onChange)="filterChanged($event)"></patron-filter-widget>

<div class="sprint-content">
  <div
    class="kanban-container p-4 d-flex overflow-auto"
    [style.height]="screenHeight - 110 + 'px'"
    #kanbanContainer>
    <ng-container [ngTemplateOutlet]="minimizedSprintContainer"></ng-container>

    @if (existTickets(notPunctuatedSprint)) {
      <app-sprint-column
        color="warning"
        title="Não pontuados"
        [sprintObj]="notPunctuatedSprint"
        (dropEmitter)="drop($event)"
        (dragStartEmitter)="ticketDropService.dragStart($event, isBeta)"
        (dragEndEmitter)="ticketDropService.dragEnd($event)"
        (openTicketModalEmitter)="openTicketModal($event)"
        (titleClicked)="minimizeSprint($event)"
        [minimizedSprints]="minimizedSprints"
        [useSprintObjLength]="true"
        [isBeta]="isBeta"></app-sprint-column>
    }

    @if (existTickets(punctuatedSprint)) {
      <app-sprint-column
        color="primary"
        title="Já pontuados"
        [sprintObj]="punctuatedSprint"
        (dropEmitter)="drop($event)"
        (dragStartEmitter)="ticketDropService.dragStart($event, isBeta)"
        (dragEndEmitter)="ticketDropService.dragEnd($event)"
        (openTicketModalEmitter)="openTicketModal($event)"
        (titleClicked)="minimizeSprint($event)"
        [minimizedSprints]="minimizedSprints"
        [isBeta]="isBeta"></app-sprint-column>
    }

    @if (existTickets(delayedAndFinishedSprint)) {
      <app-sprint-column
        color="success"
        title="Concluídos"
        [sprintObj]="delayedAndFinishedSprint"
        (dropEmitter)="drop($event)"
        (dragStartEmitter)="ticketDropService.dragStart($event, isBeta)"
        (dragEndEmitter)="ticketDropService.dragEnd($event)"
        (openTicketModalEmitter)="openTicketModal($event)"
        (titleClicked)="minimizeSprint($event)"
        [minimizedSprints]="minimizedSprints"
        [isBeta]="isBeta"></app-sprint-column>
    }

    @if (existTickets(delayedSprint)) {
      <app-sprint-column
        color="danger"
        title="Atrasados"
        [sprintObj]="delayedSprint"
        (dropEmitter)="drop($event)"
        (dragStartEmitter)="ticketDropService.dragStart($event, isBeta)"
        (dragEndEmitter)="ticketDropService.dragEnd($event)"
        (openTicketModalEmitter)="openTicketModal($event)"
        (titleClicked)="minimizeSprint($event)"
        [minimizedSprints]="minimizedSprints"
        [isBeta]="isBeta"></app-sprint-column>
    }

    @for (sprint of getObjectDateKeys(sprints); track sprint) {
      <app-sprint-column
        [title]="sprint"
        [sprintObj]="sprints[sprint]"
        (dropEmitter)="drop($event)"
        (dragStartEmitter)="ticketDropService.dragStart($event, isBeta)"
        (dragEndEmitter)="ticketDropService.dragEnd($event)"
        (openTicketModalEmitter)="openTicketModal($event)"
        (titleClicked)="minimizeSprint($event)"
        [minimizedSprints]="minimizedSprints"
        [isBeta]="isBeta">
      </app-sprint-column>
    }
  </div>
</div>

@if (loading) {
  <patron-spinner size="lg" [centered]="true"></patron-spinner>
}

<ng-template #minimizedSprintContainer>
  @if (getMinimizedSprintKeys().length) {
    <div class="mt-5 mr-4 ml-n3">
      @for (sprint of getMinimizedSprintKeys(); track sprint) {
        <div
          class="card row mb-1 cursor-pointer"
          (click)="unminimizeSprint(sprint)"
          [ngClass]="tcTicketService.getBackgroundColor(minimizedSprints[sprint])">
          <small
            class="mb-0 text-center px-2 py-1 border-round-right"
            [ngClass]="tcTicketService.getAlertColor(minimizedSprints[sprint])">
            {{ sprint }}
          </small>
        </div>
      }
    </div>
  }
</ng-template>

<div class="ticket-modal">
  <app-ticket-modal
    [visible]="showCurrentTicketModal"
    [entity]="currentTicket"
    [taskId]="currentTaskId"
    [userLogged]="user"
    (closed)="ticketModalClosed($event)"></app-ticket-modal>
</div>
